import CitiesComponent from "./components/cities-component";
import {renderContactContent} from "./render-contact-content";
import {getPage} from "./require/get-page";
import {getAlphabetCities} from "./utils/get-alphabet-cities";
import {render, RenderPosition} from "./utils/render";

export const renderCities = (contactB2CElement, container, cities) => {
  const alphabetCities = getAlphabetCities(cities);

  alphabetCities.forEach((alphabetCity) => {
    const component = new CitiesComponent({alphabetCity});
    render(container, component.getElement(), RenderPosition.BEFOREEND);
    component.getCityButtonClickHandler((cityId) => {
      contactB2CElement.dataset.loading = true;

      Array.from(container.querySelectorAll(`.cities__cityButton`))
        .filter((item) => item.dataset.active === `true` && item.dataset.cityId !== cityId)
        .forEach((item) => {
          item.dataset.active = `false`;
        });

      getPage(cityId, (data) => {
        renderContactContent(contactB2CElement.querySelector(`div`), data);
        contactB2CElement.dataset.loading = false;
      });
    });
  });
};
